module.exports = __webpack_public_path__ + "static/media/message.5a8b0ae1.png";